import BasicService from "./BasicService";

class TrackingService extends BasicService {
    constructor() {
        super();
    }
    getTrackingData(trackingId) {
        const url = `tracking/items`;
        return this.axios.get(url,
            {
                params: {
                    trackingId,
                }
            }).then(response => response.data);
    }
}

const trackingService = new TrackingService();
export default trackingService;
